import { useTranslation, Trans } from 'react-i18next';
import { Container, Row, Col } from 'reactstrap';
import Styles from './Styles.module.scss';
import { Footer } from 'app/Footer';

export const Imprint: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div>
      <Container className={Styles.container}>
        <p className={Styles.title}>{t('Imprint_Title')}</p>
        <p className={Styles.header}>{t('Imprint_SubTitle')}</p>

        <div className={Styles.addressBlock}>
          <p className={Styles.text}>{t('Imprint_Address')}</p>
        </div>

        <Row className={Styles.contactsBlock}>
          <Col className={`col-12 col-lg-3`}>
            <p className={Styles.header}>{t('Imprint_Chiefs_Header')}</p>
            <p className={Styles.text}>{t('Imprint_Chiefs_Text')}</p>
          </Col>
          <Col className={`col-12 col-lg-3`}>
            <p className={Styles.header}>{t('Imprint_Contact_Header')}</p>
            <p className={Styles.text}>
              <Trans i18nKey="Imprint_Contact_Text">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`tel:${t('Imprint_Contact_Telephone')}`}
                >
                  phone
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`mailto:${t('Imprint_Contact_Email')}`}
                >
                  email
                </a>
              </Trans>
            </p>
          </Col>
          <Col className={`col-12 col-lg-3`}>
            <p className={Styles.header}>{t('Imprint_Court_Header')}</p>
            <p className={Styles.text}>{t('Imprint_Court_Text')}</p>
          </Col>
          <Col className={`col-12 col-lg-3`}>
            <p className={Styles.header}>{t('Imprint_VATID_Header')}</p>
            <p className={Styles.text}>{t('Imprint_VATID_Text')}</p>
          </Col>
        </Row>

        <hr />

        <p className={Styles.title}>{t('Disclaimer_Title')}</p>
        <p className={Styles.header}>{t('Imprint_Responsibility_Header')}</p>
        <p className={Styles.text}>{t('Imprint_Responsibility_Text')}</p>

        <p className={Styles.header}>{t('Imprint_Copyright_Header')}</p>
        <p className={Styles.text}>{t('Imprint_Copyright_Text')}</p>

        <p className={Styles.header}>{t('Imprint_Patents_Header')}</p>
        <p className={Styles.text}>{t('Imprint_Patents_Text')}</p>
      </Container>

      <div className="splitter appContainerBottomSplitter" />
      <Footer />
    </div>
  );
};
